<div class="page  page--profile js-account">
  <div class="page__container " #page>
    <div>
      <ng-template #modalChangePassword let-c="close" let-d="dismiss">
        <wsb-modal disabledFooter="true" [primaryButtonEnable]="false" (dismiss)="d()" title="{{ 'account_changepassword' | translate }}">
          <div body>
            <div class="form-group row">
              <label class="col-sm-4" translate>change_password_new</label>
              <div class="col-sm-8 password-line">
                <input
                  [type]="showPasswordNew ? 'text' : 'password'"
                  class="form-control"
                  [formControl]="newPassword"
                  wsbAppControlValidator
                  [fc]="subaccountForm.get('password')"
                />
                <wsb-atlas-button
                  variant="icon"
                  [icon]="faPasswordNewIconShow"
                  roundButton=""
                  size="sm"
                  noHover="true"
                  (click)="showHidePassWordNew()"
                >
                </wsb-atlas-button>
                <wsb-validation-error-msg [fc]="newPassword"></wsb-validation-error-msg>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4" translate>change_password_repeat</label>
              <div class="col-sm-8 password-line">
                <input [type]="showPasswordRepeat ? 'text' : 'password'" class="form-control" [(ngModel)]="passwordCheck" />
                <wsb-atlas-button
                  variant="icon"
                  [icon]="faPasswordRepeatIconShow"
                  roundButton=""
                  size="sm"
                  noHover="true"
                  (click)="showHidePassWordRepeat()"
                >
                </wsb-atlas-button>
                <div *ngIf="passwordCheck && passwordCheck !== newPassword.value" class="invalid-feedback d-block">
                  {{ 'error_validation_password_dont_match' | translate }}
                </div>
              </div>
            </div>

            <div footer class="modal-footer">
              <wsb-atlas-button
                variant="secondary"
                class="secondary me-3"
                data-dismiss="modal"
                [label]="'common_cancel'"
                (btnClick)="closeModal()"
              ></wsb-atlas-button>
              <wsb-atlas-button
                variant="primary"
                [disabled]="passwordCheck !== newPassword.value || newPassword.invalid"
                [label]="'common_ok'"
                (btnClick)="saveNewPassword()"
              ></wsb-atlas-button>
            </div>
          </div>
        </wsb-modal>
      </ng-template>
    </div>
    <!-- modal password api -->

    <div>
      <ng-template #modalChangeApiPassword let-c="close" let-d="dismiss">
        <wsb-modal disabledFooter="true" [primaryButtonEnable]="false" (dismiss)="d()" title="{{ 'account_changepassword' | translate }}">
          <div body>
            <div class="form-group row">
              <label class="col-sm-4" translate>change_password_new</label>
              <div class="col-sm-8 password-line">
                <input
                  [type]="showPasswordApi ? 'text' : 'password'"
                  class="form-control"
                  id="newApiPassword"
                  [formControl]="newApiPassword"
                  wsbAppControlValidator
                  [fc]="subaccountForm.get('passwordApi')"
                />
                <wsb-atlas-button
                  variant="icon"
                  [icon]="faPasswordNewIconShow"
                  roundButton=""
                  size="sm"
                  noHover="true"
                  (click)="showHidePassWordApiNew()"
                >
                </wsb-atlas-button>
                <wsb-validation-error-msg [fc]="newApiPassword"></wsb-validation-error-msg>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4" translate>change_password_repeat</label>
              <div class="col-sm-8 password-line">
                <input [type]="showPasswordApiRepeat ? 'text' : 'password'" class="form-control" [(ngModel)]="passwordApiCheck" />
                <wsb-atlas-button
                  variant="icon"
                  [icon]="faPasswordApiRepeatIconShow"
                  roundButton=""
                  size="sm"
                  noHover="true"
                  (click)="showHidePassWordApiRepeat()"
                >
                </wsb-atlas-button>
                <div *ngIf="passwordApiCheck && passwordApiCheck !== newApiPassword.value" class="invalid-feedback d-block">
                  {{ 'error_validation_password_dont_match' | translate }}
                </div>
              </div>
            </div>

            <div footer class="modal-footer">
              <wsb-atlas-button
                variant="secondary"
                class="secondary me-3"
                data-dismiss="modal"
                [label]="'common_cancel'"
                (btnClick)="closeModalPasswordApi()"
              ></wsb-atlas-button>
              <wsb-atlas-button
                variant="primary"
                [disabled]="passwordApiCheck !== newApiPassword.value || newApiPassword.invalid"
                [label]="'common_ok'"
                (btnClick)="saveNewPasswordApi()"
              ></wsb-atlas-button>
            </div>
          </div>
        </wsb-modal>
      </ng-template>
    </div>

    <h1 *ngIf="!editing" class="page__title  h2" translate>settings_subaccounts_create_title</h1>
    <h1 *ngIf="editing" class="page__title  h2" translate>settings_subaccounts_edit_title</h1>
    <div class="my-5">
      <form [formGroup]="subaccountForm">
        <div>
          <h3 class="my-5" translate>settings_subaccounts_subtitle_general_settings</h3>
          <div class="page__form-wrap">
            <ng-container>
              <div class="form-group row ">
                <label class="col-sm-4" translate>account_profile_title</label>
                <div class="col-sm-8">
                  <ng-container>
                    <ng-select
                      id="profile"
                      bindValue="id"
                      formControlName="idSubaccountProfile"
                      [items]="profiles"
                      bindLabel="value"
                      [clearable]="false"
                      class="form-control"
                    >
                    </ng-select>
                  </ng-container>
                </div>
              </div>
            </ng-container>

            <ng-container>
              <div class="form-group row" formGroupName="options">
                <label class="col-sm-4" translate>settings_accounts_language</label>
                <div class="col-sm-8">
                  <ng-container>
                    <ng-select
                      id="language"
                      bindValue="id"
                      formControlName="idLanguage"
                      [items]="languages"
                      bindLabel="value"
                      [clearable]="false"
                      class="form-control"
                    >
                    </ng-select>
                  </ng-container>
                </div>
              </div>
            </ng-container>

            <ng-container>
              <div class="form-group row" formGroupName="options">
                <label class="col-sm-4" translate>settings_accounts_data_format</label>

                <div class="col-sm-8 d-flex align-items-center">
                  <div id="dateFormatForm" class="form-check-inline">
                    <label class="radio-custom">
                      <input type="radio" id="dayMonthYear" name="dfeu" formControlName="dfeu" [value]="true" />
                      <span class="radio-custom__radio"></span>
                      <span class="radio-custom__label" translate>settings_gg_mm_aaaa</span>
                    </label>
                    <label class="radio-custom">
                      <input type="radio" id="monthDayYear" name="dfeu" formControlName="dfeu" [value]="false" />
                      <span class="radio-custom__radio"></span>
                      <span class="radio-custom__label" translate>settings_mm_gg_aaaa</span>
                    </label>
                    <wsb-validation-error-msg [fc]="subaccountForm.get('options.dfeu')"></wsb-validation-error-msg>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container>
              <div class="form-group row" formGroupName="options">
                <label class="col-sm-4" translate>settings_accounts_hour_format</label>

                <div class="col-sm-8 d-flex align-items-center">
                  <div id="hourFormatForm" class="form-check-inline">
                    <label class="radio-custom">
                      <input type="radio" id="24hr" name="use24" formControlName="use24" [value]="true" />
                      <span class="radio-custom__radio"></span>
                      <span class="radio-custom__label" translate>settings_accounts_24</span>
                    </label>
                    <label class="radio-custom">
                      <input type="radio" id="12hr" name="use24" formControlName="use24" [value]="false" />
                      <span class="radio-custom__radio"></span>
                      <span class="radio-custom__label" translate>settings_accounts_12</span>
                    </label>
                    <wsb-validation-error-msg [fc]="subaccountForm.get('options.use24')"></wsb-validation-error-msg>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container>
              <div class="form-group row">
                <label class="col-sm-4" translate>settings_subaccounts_reseller</label>

                <div class="col-sm-8 d-flex align-items-center">
                  <div
                    id="hourFormatForm"
                    class="form-check-inline"
                    [ngClass]="{ 'disable-reseller': isDisableResellerSubaccount() || null }"
                  >
                    <label class="radio-custom">
                      <input type="radio" id="isSuperaccount1" name="isSuperaccount" formControlName="isSuperaccount" [value]="true" />
                      <span class="radio-custom__radio"></span>
                      <span class="radio-custom__label" translate>common_yes</span>
                    </label>
                    <label class="radio-custom">
                      <input
                        type="radio"
                        id="isSuperaccount2"
                        name="isSuperaccount"
                        formControlName="isSuperaccount"
                        [value]="false"
                        [attr.disabled]="isDisableResellerSubaccount() || null"
                      />
                      <span class="radio-custom__radio"></span>
                      <span class="radio-custom__label" translate>common_no</span>
                    </label>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="showDefaultSender">
              <div class="form-group row validator-align-items" formGroupName="defaultSender">
                <label class="col-sm-4" translate>settings_accounts_sms_default_sender</label>
                <div class="col-sm-8">
                  <ng-container>
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      formControlName="defaultSender"
                      wsbAppControlValidator
                      [fc]="subaccountForm.get('defaultSender.defaultSender')"
                    />

                    <wsb-validation-error-msg [fc]="subaccountForm.get('defaultSender.defaultSender')"></wsb-validation-error-msg>
                  </ng-container>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="showDefaultSender">
              <div class="form-group" formGroupName="defaultSender">
                <div class="row">
                  <label class="col-sm-4" translate>settings_subaccounts_locksender</label>

                  <div class="col-sm-8 d-inline-flex align-items-center">
                    <wsb-ui-checkbox
                      class="mb-1"
                      [checked]="subaccountForm.get('defaultSender.isSenderLock').value"
                      formControlName="isSenderLock"
                    ></wsb-ui-checkbox>
                  </div>
                  <!-- (checkedChange)="isSenderLockChange()" -->
                </div>
                <!--
                <div class="col-sm-1 d-flex align-items-center">
                  <ng-container>
                    <div style="margin-left: 1px;" class="ag-wrapper ag-theme-alpine ag-input-wrapper ag-checkbox-input-wrapper" role="presentation">
                      <input class="ag-input-field-input ag-checkbox-input" type="checkbox" />
                    </div>

                    <wsb-validation-error-msg [fc]="subaccountForm.get('attribute.name')"></wsb-validation-error-msg>
                  </ng-container>
                </div> -->
              </div>
            </ng-container>

            <!-- <ng-container *ngIf="!isIta">
              <div class="form-group row" formGroupName="defaultSender">
                <label class="col-sm-4" translate>isSenderLock</label>

                <div class="col-sm-8 d-flex align-items-center">
                  <div id="hourFormatForm" class="form-check-inline">
                    <label class="radio-custom">
                      <input type="radio" name="isSenderLock" formControlName="isSenderLock" value="true" />
                      <span class="radio-custom__radio"></span>
                      <span class="radio-custom__label" translate>isSenderLock</span>
                    </label>
                    <label class="radio-custom">
                      <input type="radio" name="isSenderLock" formControlName="isSenderLock" value="false" />
                      <span class="radio-custom__radio"></span>
                      <span class="radio-custom__label" translate>isSenderLock</span>
                    </label>
                    <wsb-validation-error-msg [fc]="subaccountForm.get('options.use24')"></wsb-validation-error-msg>
                  </div>
                </div>
              </div>
            </ng-container> -->
          </div>
          <h3 class="my-5" translate>settings_subaccounts_subtitle_user_owner_data</h3>
          <div class="page__form-wrap">
            <ng-container *ngIf="!editing">
              <!-- PWSB-2363 For new subaccount the login is the registration email -->
              <div class="form-group row validator-align-items">
                <label class="col-sm-4" translate>user_username</label>
                <div
                  class="tooltip-custom border rounded-circle border-1"
                  #tooltip="matTooltip"
                  matTooltipPosition="above"
                  matTooltipClass="tooltip-class"
                  matTooltip="{{ 'user_auth0_email_tooltips_info' | translate }}"
                >
                  <p>?</p>
                </div>
                <div class="col-sm-8">
                  <ng-container>
                    <input
                      type="text"
                      class="form-control"
                      readonly
                      onfocus="this.removeAttribute('readonly');"
                      style="opacity: 1;"
                      autocomplete="off"
                      formControlName="login"
                      wsbAppControlValidator
                      [fc]="subaccountForm.get('login')"
                    />
                    <wsb-validation-error-msg [fc]="subaccountForm.get('login')"></wsb-validation-error-msg>
                  </ng-container>
                </div>
              </div>
            </ng-container>

            <ng-container>
              <div class="form-group row" *ngIf="this.editing && !isUniversalLogin()">
                <label class="col-sm-4" translate>settings_subaccount_password_webapp</label>
                <div class="col-sm-8">
                  <button class="btn btn-primary btn-sm" (click)="openModalChangPassword()" translate>
                    account_changepassword
                  </button>
                </div>
              </div>
            </ng-container>

            <ng-container>
              <div class="form-group row validator-align-items" *ngIf="!this.editing">
                <label class="col-sm-4" translate>settings_subaccount_password_webapp</label>
                <div class="col-sm-8 password-line">
                  <input
                    [type]="showPasswordNew ? 'text' : 'password'"
                    class="form-control"
                    formControlName="password"
                    wsbAppControlValidator
                    [fc]="subaccountForm.get('password')"
                  />
                  <wsb-atlas-button
                    variant="icon"
                    [icon]="faPasswordNewIconShow"
                    roundButton=""
                    size="sm"
                    noHover="true"
                    (click)="showHidePassWordNew()"
                  >
                  </wsb-atlas-button>
                  <div>
                    <wsb-validation-error-msg [fc]="subaccountForm.get('password')"></wsb-validation-error-msg>
                  </div>
                </div>
              </div>
              <!-- password api -->
              <ng-container>
                <div class="form-group row" *ngIf="this.editing">
                  <label class="col-sm-4" translate>settings_subaccount_password_api</label>
                  <div
                    class="tooltip-custom border rounded-circle border-1"
                    #tooltip="matTooltip"
                    matTooltipPosition="above"
                    matTooltipClass="tooltip-class"
                    matTooltip="{{ 'settings_subaccounts_passwordapi_tooltip' | translate }}"
                  >
                    <p>?</p>
                  </div>
                  <div class="col-sm-8">
                    <button class="btn btn-primary btn-sm" (click)="openModalChangPasswordApi()" translate>
                      account_changepassword
                    </button>
                  </div>
                </div>
              </ng-container>

              <div class="form-group row validator-align-items" *ngIf="!this.editing">
                <label class="col-sm-4" translate>settings_subaccount_password_api</label>
                <div
                  class="tooltip-custom border rounded-circle border-1"
                  #tooltip="matTooltip"
                  matTooltipPosition="above"
                  matTooltipClass="tooltip-class"
                  matTooltip="{{ 'settings_subaccounts_passwordapi_tooltip' | translate }}"
                >
                  <p>?</p>
                </div>
                <div class="col-sm-8 password-line">
                  <input
                    [type]="showPasswordApi ? 'text' : 'password'"
                    class="form-control"
                    id="passwordApi"
                    formControlName="passwordApi"
                    wsbAppControlValidator
                    [fc]="subaccountForm.get('passwordApi')"
                  />
                  <wsb-atlas-button
                    variant="icon"
                    [icon]="faPasswordApiIconShow"
                    roundButton=""
                    size="sm"
                    noHover="true"
                    (click)="showHidePassWordApiNew()"
                  >
                  </wsb-atlas-button>
                  <div *ngIf="!passwordApiOption" class="invalid-feedback d-block">
                    {{ 'validate_password' | translate }}
                  </div>
                </div>
              </div>
              <!--

              <div class="form-group row" *ngIf="!this.editing">
                <label class="col-sm-4" translate>account_password</label>
                <div class="col-sm-8">
                  <ng-container>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="password"
                      wsbAppControlValidator
                      (keydown.space)="$event.preventDefault()"
                      [fc]="subaccountForm.get('password')"
                    />
                    <wsb-validation-error-msg [fc]="subaccountForm.get('password')"></wsb-validation-error-msg>
                  </ng-container>
                </div>
              </div> -->
            </ng-container>

            <ng-container>
              <div class="form-group row validator-align-items" formGroupName="attribute">
                <label class="col-sm-4" translate>account_name</label>
                <div class="col-sm-8">
                  <ng-container>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="name"
                      wsbAppControlValidator
                      [fc]="subaccountForm.get('attribute.name')"
                    />
                    <wsb-validation-error-msg [fc]="subaccountForm.get('attribute.name')"></wsb-validation-error-msg>
                  </ng-container>
                </div>
              </div>
            </ng-container>

            <ng-container>
              <div class="form-group row validator-align-items" formGroupName="attribute">
                <label class="col-sm-4" translate>account_surname</label>
                <div class="col-sm-8">
                  <ng-container>
                    <input
                      type="text"
                      class="form-control"
                      id="surname"
                      formControlName="surname"
                      wsbAppControlValidator
                      [fc]="subaccountForm.get('attribute.surname')"
                    />
                    <wsb-validation-error-msg [fc]="subaccountForm.get('attribute.surname')"></wsb-validation-error-msg>
                  </ng-container>
                </div>
              </div>
            </ng-container>

            <ng-container>
              <div class="form-group row validator-align-items" formGroupName="attribute">
                <label class="col-sm-4" translate>user_email</label>
                <div
                  class="tooltip-custom border rounded-circle border-1"
                  #tooltip="matTooltip"
                  matTooltipPosition="above"
                  matTooltipClass="tooltip-class"
                  matTooltip="{{ 'user_email_tooltips_info' | translate }}"
                >
                  <p>?</p>
                </div>
                <div class="col-sm-8">
                  <ng-container>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="email"
                      wsbAppControlValidator
                      [fc]="subaccountForm.get('attribute.email')"
                    />
                    <wsb-validation-error-msg [fc]="subaccountForm.get('attribute.email')"></wsb-validation-error-msg>
                  </ng-container>
                </div>
              </div>
            </ng-container>

            <ng-container>
              <div class="form-group row validator-align-items" formGroupName="attribute">
                <label class="col-sm-4" translate>account_cell</label>
                <div class="col-sm-8">
                  <ng-container>
                    <wsb-atlas-inputphone
                      #inputPhone
                      name="intlTelInputName"
                      [cssClass]="'form-control'"
                      [formControlName]="'mobile'"
                    ></wsb-atlas-inputphone>

                    <!--
                    <input
                      type="text"
                      class="form-control"
                      id="mobile"
                      formControlName="mobile"
                      wsbAppControlValidator
                      [fc]="subaccountForm.get('attribute.mobile')"
                    /> -->
                    <wsb-validation-error-msg [fc]="inputPhone.phoneNumber"></wsb-validation-error-msg>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>

          <h3 class="my-5" translate>settings_subaccounts_subtitle_account_company</h3>
          <div class="page__form-wrap">
            <ng-container>
              <ng-container>
                <div class="form-group row validator-align-items" formGroupName="attribute">
                  <label class="col-sm-4" translate>account_company</label>
                  <div class="col-sm-8">
                    <ng-container>
                      <input
                        type="text"
                        class="form-control"
                        id="companyName"
                        formControlName="companyName"
                        wsbAppControlValidator
                        [fc]="subaccountForm.get('attribute.companyName')"
                      />
                      <wsb-validation-error-msg [fc]="subaccountForm.get('attribute.companyName')"></wsb-validation-error-msg>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container>
                <div class="form-group row validator-align-items" formGroupName="attribute">
                  <label class="col-sm-4" translate>account_piva</label>
                  <div class="col-sm-8">
                    <ng-container>
                      <input
                        type="text"
                        class="form-control"
                        id="vat"
                        formControlName="vat"
                        wsbAppControlValidator
                        [fc]="subaccountForm.get('attribute.vat')"
                      />
                    </ng-container>
                  </div>
                </div>
              </ng-container>
              <ng-container>
                <div class="form-group row" formGroupName="attribute">
                  <label class="col-sm-4" translate>account_cf</label>
                  <div class="col-sm-8">
                    <ng-container>
                      <input
                        type="text"
                        class="form-control"
                        id="fiscalCode"
                        formControlName="fiscalCode"
                        oninput="this.value = this.value.toUpperCase()"
                        wsbAppControlValidator
                        [fc]="subaccountForm.get('attribute.fiscalCode')"
                      />
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container>
                <div class="form-group row validator-align-items" formGroupName="attribute">
                  <label class="col-sm-4" translate>account_address</label>
                  <div class="col-sm-8">
                    <ng-container>
                      <input
                        type="text"
                        class="form-control"
                        id="address"
                        formControlName="address"
                        wsbAppControlValidator
                        [fc]="subaccountForm.get('attribute.address')"
                      />
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container>
                <div class="form-group row" formGroupName="attribute">
                  <label class="col-sm-4" translate>account_zip</label>
                  <div class="col-sm-8">
                    <ng-container>
                      <input
                        type="text"
                        class="form-control"
                        id="zipCode"
                        formControlName="zipCode"
                        wsbAppControlValidator
                        [fc]="subaccountForm.get('attribute.zipCode')"
                      />
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container>
                <div class="form-group row validator-align-items" formGroupName="attribute">
                  <label class="col-sm-4" translate>account_city</label>
                  <div class="col-sm-8">
                    <ng-container>
                      <input
                        type="text"
                        class="form-control"
                        id="city"
                        formControlName="city"
                        wsbAppControlValidator
                        [fc]="subaccountForm.get('attribute.city')"
                      />
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container>
                <div class="form-group row" formGroupName="attribute">
                  <label class="col-sm-4" translate>account_province</label>
                  <div class="col-sm-8">
                    <ng-container>
                      <input
                        type="text"
                        class="form-control"
                        id="province"
                        formControlName="province"
                        wsbAppControlValidator
                        [fc]="subaccountForm.get('attribute.province')"
                      />
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container>
                <div class="form-group row validator-align-items" formGroupName="attribute">
                  <label class="col-sm-4" translate>account_phone</label>
                  <div class="col-sm-8">
                    <ng-container>
                      <wsb-atlas-inputphone #inputPhone2 [cssClass]="'form-control'" [formControlName]="'phone'"></wsb-atlas-inputphone>
                      <wsb-validation-error-msg [fc]="inputPhone2.phoneNumber"></wsb-validation-error-msg>

                      <!-- <input
                        type="text"
                        class="form-control"
                        id="phone"
                        formControlName="phone"
                        wsbAppControlValidator
                        [fc]="subaccountForm.get('attribute.phone')"
                      /> -->
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container>
                <div class="form-group row" formGroupName="attribute">
                  <label class="col-sm-4" translate>account_fax</label>
                  <div class="col-sm-8">
                    <ng-container>
                      <input
                        type="text"
                        class="form-control"
                        id="fax"
                        formControlName="fax"
                        wsbAppControlValidator
                        [fc]="subaccountForm.get('attribute.fax')"
                      />
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container>
                <div class="form-group row validator-align-items" formGroupName="attribute">
                  <label class="col-sm-4" translate>account_invoicing_email</label>
                  <div class="col-sm-8">
                    <ng-container>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="invoicingEmail"
                        wsbAppControlValidator
                        [fc]="subaccountForm.get('attribute.invoicingEmail')"
                      />
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #modalForceOverWrite let-c="close" let-d="dismiss">
              <wsb-modal
                (primary)="modalForceOverWriteSubmit()"
                (dismiss)="d()"
                primaryButtonText="common_override"
                cancelButtonEnable="true"
                title="{{ 'contact_exists_confirm_title' | translate }}"
                text="{{ 'contact_exists_confirm' | translate }}"
              ></wsb-modal>
            </ng-template>

            <!--            <div class="form-group row">-->
            <!--              <label for="mobilePhone" class="col-sm-4" translate>account_cell</label>-->
            <!--              <div class="col-sm-8">-->
            <!--                <input type="text" class="form-control" id="mobilePhone" formControlName="mobilePhone"-->
            <!--                       wsbAppControlValidator [fc]="profileForm.get('mobilePhone')"/>-->
            <!--                <wsb-validation-error-msg [fc]="profileForm.get('mobilePhone')"></wsb-validation-error-msg>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="form-group row">-->
            <!--              <label for="phone" class="col-sm-4" translate>account_phone</label>-->
            <!--              <div class="col-sm-8">-->
            <!--                <input type="text" class="form-control" id="phone" formControlName="phone"-->
            <!--                       wsbAppControlValidator [fc]="profileForm.get('phone')"/>-->
            <!--                <wsb-validation-error-msg [fc]="profileForm.get('phone')"-->
            <!--                                          [customMsg]="'Not a valid phone number'"></wsb-validation-error-msg>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="form-group row">-->
            <!--              <label for="fax" class="col-sm-4" translate>account_fax</label>-->
            <!--              <div class="col-sm-8">-->
            <!--                <input type="text" class="form-control" id="fax" formControlName="fax"-->
            <!--                       wsbAppControlValidator [fc]="profileForm.get('fax')"/>-->
            <!--                <wsb-validation-error-msg [fc]="profileForm.get('fax')"></wsb-validation-error-msg>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>

        <!--        <div formGroupName="password">-->
        <!--          <h3 class="my-5" translate>user_title_security</h3>-->
        <!--          <div class="page__form-wrap">-->
        <!--            <div class="form-group row">-->
        <!--              <label for="password" class="col-sm-4" translate>user_password</label>-->
        <!--              <div class="col-sm-8">-->
        <!--                <input type="password" class="form-control" id="password" formControlName="password"/>-->
        <!--              </div>-->
        <!--              <button class="btn btn-secondary" type="button" (click)="openPasswordModal()" translate>-->
        <!--                user_changepassword-->
        <!--              </button>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </form>

      <div class="page__actions  actions-bar" #actionsBar style="z-index: 1" *ngIf="subaccountForm">
        <span class="actions-bar__bg"></span>
        <div class="actions-bar__container" toastContainer></div>
        <div class="actions-bar__container  actions-bar__container--actions">
          <div class="d-flex">
            <button
              #submitBtn
              (click)="save()"
              class="btn btn-primary btn-sm"
              [disabled]="
                (subaccountForm.pristine && !selectionChanged) ||
                subaccountForm.invalid ||
                inputPhone.phoneNumber.invalid ||
                inputPhone2.phoneNumber.invalid ||
                !passwordApiOption ||
                isEmptyPasswordForm
              "
              translate
            >
              common_save
            </button>
            <button #submitBtn (click)="goBack()" class="btn  btn-secondary ms-3  btn-sm" translate>common_back</button>
            <button
              *ngIf="subaccountForm.dirty || selectionChanged"
              type="button"
              class="btn btn-link btn-sm ms-4"
              (click)="resetForm()"
              translate
            >
              common_cancel
            </button>
          </div>
          <div *ngIf="!subaccountForm.pristine" class="mt-2">
            <small translate>settings_subaccounts_mandatory_field</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
